import { MutableRefObject } from 'react'
import ReactToPrint from 'react-to-print'

import PrintIcon from 'ui-component-library/icons/print.svg'
import style from '../IconButton/style.scss'

type Props = {
  children: string
  contentRef: MutableRefObject<HTMLDivElement | null>
}

function PrintButton({ children, contentRef }: Props) {
  return (
    <button className={style.wrapper}>
      <ReactToPrint
        content={() => contentRef.current}
        pageStyle={style.printWrapper}
        trigger={() => (
          <span className={style.printLink}>
            <PrintIcon className={style.icon} />
            {children}
          </span>
        )}
      />
    </button>
  )
}

export default PrintButton
